/** Pesan error pertama dalam struktur error react-hook-form, termasuk error bersarang di array/objek. */
export const firstErrorMessage = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object') return undefined;
  const { message } = error as { message?: unknown };
  if (typeof message === 'string' && message) return message;
  for (const value of Object.values(error as Record<string, unknown>)) {
    if (value && typeof value === 'object' && !(value instanceof Element)) {
      const nested = firstErrorMessage(value);
      if (nested) return nested;
    }
  }
  return undefined;
};
